import { Center, ProgressCircle } from '@chakra-ui/react';

const Loading = () => {
    return (
        <Center mt={4}>
            <ProgressCircle.Root size="sm" value={null}>
                <ProgressCircle.Circle>
                    <ProgressCircle.Track />
                    <ProgressCircle.Range stroke="orange.400" />
                </ProgressCircle.Circle>
            </ProgressCircle.Root>
        </Center>
    );
}

export default Loading;